// extracted by mini-css-extract-plugin
export default {"sametasks":"tasklistm_sametasks__3ooFb"};